import {
  posConfigurationGroupFields,
  posPanelConfigurationFields,
  posPanelConfigurations,
} from 'src/enums/posPanelConfigurations'
import { Country } from '../../enums/countries'

const getItemsGroupedByTag = (items: IItemPOS[]): IItemsPOSGrouped[] => {
  const response: IItemsPOSGrouped[] = []
  items?.forEach(item => {
    const tagIndex = response.findIndex(t => t.tag === (item.tag || 'sin asignar'))
    if (tagIndex === -1) response.push({ tag: item.tag || 'sin asignar', items: [item] })
    else response[tagIndex].items.push(item)
  })
  return response.sort((a, b) => a.tag.localeCompare(b.tag))
}

const getPanelConfigurationField = (
  country: number,
  posStep: number,
): IPOSPanelConfiguration[] => {
  const fieldsList: IPOSPanelConfigurationField[] = Object.values(
    posPanelConfigurationFields,
  )
  return Object.values(posConfigurationGroupFields).map(groupField => {
    const fields: IPOSPanelConfigurationField[] = fieldsList
      .filter(field => {
        let toList = true
        if (field.countries) toList = field.countries.some(c => c === country)
        if (field.posSteps) toList = field.posSteps.some(c => c === posStep)
        return toList && groupField.type === field.groupBy
      })
      .map(field => {
        if (country === Country.SV) {
          let name = field.name
          switch (field.type) {
            case posPanelConfigurations.payOrder:
              name = 'Factura sin IVA'
              break
            case posPanelConfigurations.payReceipt:
              name = 'Crédito fiscal'
              break
            default:
              name = field.name
              break
          }
          return { ...field, name }
        } else return field
      })
    return { ...groupField, fields }
  })
}

export { getItemsGroupedByTag, getPanelConfigurationField }
